<template>
	<div class="full">
		<div class="p11">
			<div class="full" style="background-color: #fc1623;"></div>
			<div class="p2_ele1"><img src="../img/p2_ele1.png" /></div>	
			<div class="p2_button2_on" v-show="nextBuff"><img src="../img/p2_button2_on.png" /></div>	
			<div class="p2_button2_off" style="-webkit-animation-delay: 2s;" v-show="!nextBuff" v-hammer:tap="next"><img src="../img/p2_button2_off.png" /></div>
			<div class="p11_img4_img animated fadeInDown"><img src="../img/p11_img4_img.png" /></div>
			<div class="p11_img3_img" v-hammer:tap="rule"><img src="../img/p11_img3_img.png" /></div>
			<div class="p11_img2_img" v-hammer:tap="mine"><img src="../img/p11_img2_img.png" /></div>
			<div class="p11_1" v-hammer:tap="bgm">
				<div class="p11_1_img2_img"><img src="../img/p11_1_img2_img.png" /></div>
				<div class="p11_1_img1_img" v-if="bgmIsPlay"><img src="../img/p11_1_img1_img.png" /></div>
			</div>
			<div class="gift_ele1">
				<img src="../img/gift_ele1.png" />
			</div>
<!-- 			<div class="gift_container flex">
				<div class="gift_box" v-for="item in 12" :key="item">
					<img src="../img/gift_1.png" />
					<div class="gift_icon"><img src="../img/gift_icon_1.png" /></div>
				</div>
			</div> -->
		</div>
		<transition name="fade">
			<rule v-if="ruleShow" @ruleBack="ruleBack"  />
		</transition>
		<transition name="fade">
			<box style="z-index: 9999;" v-if="boxShow" @back="mine" />
		</transition>
		<transition name="fade">
			<mine v-if="mineShow" @back="mineShow = false" />
		</transition>		
	</div>
</template>

<style scoped>
.gift_ele1{
	position: absolute;
	width: 93.7%;
	height: 44.2%;
	left: 3.2%;
	top: 32.4%;
}
.p2_ele1{
	position: absolute;
	width: 50.3%;
	left: 25.2%;
	top: 26.5%;
}	
.p2_ele2{
	position: absolute;
	width: 77.6%;
	left: 11.2%;
	top: 59.5%;
}	

.p2_button2_off{
	position: absolute;
	width: 43.9%;
	left: 28.5%;
	top: 79.1%;
}
.p2_button2_on{
	position: absolute;
	width: 43.9%;
	left: 28.5%;
	top: 79.5%;
}
.p11_img20_img{position:absolute;left:0.00%;top:0.00%;width:100.00%;height:100.00%;}
.p11_img4_img{position:absolute;left:14.27%;top:14.07%;width:72.13%;height:13.62%;}
.p11_img3_img{position:absolute;left:0.00%;top:21.9%;width:18.27%;height:7.48%;}
.p11_img2_img{position:absolute;left:88.53%;top:24.04%;width:9.20%;height:5.95%;}
.p11_1_img2_img{position:absolute;left:0.00%;top:3.19%;width:100.00%;height:96.81%;}
.p11_1_img1_img{position:absolute;left:0.00%;top:0.00%;width:100.00%;height:100.00%;}
.p11_1{position:absolute;left:88.53%;top:17.07%;width:9.20%;height:5.95%;}
.p11{position:absolute;left:0.00%;top:0.00%;width:100%;height:100%;}
.gift_container{
	position: absolute;
	width: 93.7%;
	left: 3.2%;
	top: 32.4%;
	background-color: white;
	border-radius: 10px;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
	box-sizing: border-box;
	padding: 20px 10px;
}
.gift_box{
	position: relative;
	width: 22%;
	margin-bottom: 15px;
}
.gift_icon{
	position: absolute;
	right: -12%;
	top: -16%;
	width: 40%;
	z-index: 10;
}
</style>
<script>
	export default {
		data() {
			return {
				nextBuff:false,
				checkBuff:false,
				ruleShow:false,
				button:0,
				boxShow:false,
				mineShow:false
			};
		},
		computed: {
			bgmIsPlay() {
				return this.$store.state.bgmIsPlay
			}
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			bgm(){
				this.$emit('bgm')
			},
			next(){		
				if(!this.nextBuff && this.button==0){
					this.button = 2
					this.nextBuff = true
					setTimeout(()=>{
						this.boxShow = true
					},100)
					this.$store.commit('playYinxiao',{name:'tap'})
				}

			},
			check(){
				if(!this.checkBuff && this.button==0){
					this.button = 1
					this.checkBuff = true
					setTimeout(()=>{
						this.$store.commit('setCurrentPage', {
							page: 'game1'
						})
					},300)
					this.$store.commit('playYinxiao',{name:'tap'})
				}				
			},
			rule(){
				this.ruleShow = true
			},
			ruleBack(){
				this.ruleShow = false
			},
			mine(){
				this.ruleShow = false
				this.boxShow = false
				this.mineShow = true
			}
		},
		components: {

		}
	}
</script>
